// typical import
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Only animate if elements exist
const fadeInLeftElements = document.querySelectorAll('.fade-in-left');
if (fadeInLeftElements.length > 0) {
    gsap.from('.fade-in-left',
    {
        scrollTrigger: {
            trigger : '.fade-in-left',
            start: '20px 80%',
            end: '+=50%',
            //toggleActions:'reverse pause reverse pause',
            scrub: true,
            markers: false,
            //onEnter:() => console.log("enter")
        },
        x:100,
        opacity:0,
        duration:3
        // stagger:0.1,
    });
}

const fadeInRightElements = document.querySelectorAll('.fade-in-right');
if (fadeInRightElements.length > 0) {
    gsap.from('.fade-in-right',
    {
        scrollTrigger: {
            trigger : '.fade-in-right',
            start: '20px 80%',
            end: '+=50%',
            //toggleActions:'reverse pause reverse pause',
            scrub: true,
            markers: false,
            //onEnter:() => console.log("enter")
        },
        x:-100,
        opacity:0,
        duration:3
        // stagger:0.1,
    });
}